












































































import { Component, Vue } from 'vue-property-decorator'
@Component({
	name: 'ButtonFour'
})
export default class ButtonFour extends Vue {
}
